import type { StickyCardProps, StickyCardPropsServer } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";
import { RichTextRenderer } from "../../../renderer/RichTextRenderer";

const StickyCard = ({ children, ...rest }: StickyCardPropsServer) => {
  return (
    <LazyComponent<StickyCardProps> name="StickyCard" {...rest}>
      <RichTextRenderer content={children} />
    </LazyComponent>
  );
};

export default StickyCard;
